import { Helmet } from "react-helmet-async"
import { useLocation } from "../../../router-utils"
import { type INewRateSheetFormSchema, NewRateSheet } from "../../../RateSheets"

export default function NewRateSheetPage() {
	const location = useLocation()

	const locationState = location.state as
		| { initialValues?: INewRateSheetFormSchema }
		| null
		| undefined

	return (
		<>
			<Helmet>
				<title>New Rate Sheet</title>
			</Helmet>
			<NewRateSheet initialValues={locationState?.initialValues} />
		</>
	)
}
